import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Sidebar } from "./Sidebar";
import { ForceChangeDialog } from "../shared/ForceChangeDialog";

export function AdminShell() {
    const { user, loading } = useAuth();
    if (loading) return <FullScreenLoader />;
    if (!user) return <Navigate to="/login" replace />;
    return (
        <div className="min-h-screen flex">
            <Sidebar />
            <main className="flex-1 min-w-0">
                <div className="max-w-[1400px] mx-auto px-8 py-10">
                    <Outlet />
                </div>
            </main>
            {user?.auth?.must_change && <ForceChangeDialog />}
        </div>
    );
}

function FullScreenLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-muted text-sm">Loading…</div>
        </div>
    );
}
